import React from 'react';

import Encoder from './Encoder';

const Encoders = props => {
    var rendered = [];

    for (var i = 0; i < props.encoders.length; i++) {
        var encoder = props.encoders[i];
        if (encoder.simpleName.toLowerCase().indexOf(props.term) >= 0) {
            rendered.push(
                <Encoder {...props}
                    key={'encoder-' + encoder.encoderID + '-' + i}
                    encoder={encoder}/>
            );
        }
    }

    return <div>{rendered}</div>;
}

export default Encoders;
